import { Controller } from "@hotwired/stimulus"

// Pauses the CSS marquee animation on hover and respects prefers-reduced-motion.
// The infinite loop is driven by CSS @keyframes curation-scroll-l (50 % translateX
// trick with duplicated DOM sets). This controller only handles pause-on-hover and
// the reduced-motion override — no JS animation engine needed.
export default class extends Controller {
  static targets = ["row"]

  connect() {
    if (this.prefersReducedMotion) return

    this.element.addEventListener("mouseenter", this.#pause)
    this.element.addEventListener("mouseleave", this.#resume)
    this.element.addEventListener("focusin",    this.#pause)
    this.element.addEventListener("focusout",   this.#resume)
  }

  disconnect() {
    this.element.removeEventListener("mouseenter", this.#pause)
    this.element.removeEventListener("mouseleave", this.#resume)
    this.element.removeEventListener("focusin",    this.#pause)
    this.element.removeEventListener("focusout",   this.#resume)
  }

  get prefersReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches
  }

  #pause = () => {
    this.rowTargets.forEach(row => {
      row.style.animationPlayState = "paused"
    })
  }

  #resume = () => {
    this.rowTargets.forEach(row => {
      row.style.animationPlayState = "running"
    })
  }
}
